var map = {
	"./remark/pages/Buy": [
		"0Lu0",
		9,
		"c496",
		"6aa0"
	],
	"./remark/pages/Buy.vue": [
		"0Lu0",
		9,
		"c496",
		"6aa0"
	],
	"./remark/pages/Order": [
		"ct5+",
		9,
		"c496",
		"57b8"
	],
	"./remark/pages/Order.vue": [
		"ct5+",
		9,
		"c496",
		"57b8"
	],
	"./remark/styles/buy.scss": [
		"T38x",
		7,
		"7638"
	],
	"./remark/styles/order.scss": [
		"8VeH",
		7,
		"74be"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0dLw";
module.exports = webpackAsyncContext;